import { environment } from '../../environments/environment'
import { Exception } from '../exception';
import { appInjector } from '../app-injector';
import { HttpClient } from '@angular/common/http';



export class ExceptionHttp extends Exception {
  constructor(message: string, public status: number, public errores: any) {
    super(message);
  }
}


export abstract class ApiService {
  protected urlBase: string = environment.urlBase + 'api/';

  constructor(protected nombreRecurso: string) {

  }
  private _http: HttpClient;
  protected get http(): HttpClient {
    if (!this._http) {
      this._http = appInjector.get(HttpClient);
    }
    return this._http;
  }

  protected url(url: string): string {
    url = this.urlBase + (this.nombreRecurso ? this.nombreRecurso + (url !== '' ? '/' : '') : '') + url
    return url;
  }
  
}
